import isPfdodModule from './isPfdodCheck';
import { API_MODULE_NAME } from './const.js'

const mixin = {
  mixins: [isPfdodModule],

  computed: {
    dataModule() {
      const {isPfdodModule} = this;
      return isPfdodModule ? [API_MODULE_NAME] : [];
    },
  },
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/moduleShow.js